<template>
  <div id="index">
    <div class="background"></div>
    <router-link class="start-button" to="home">开始游戏</router-link>
  </div>
</template>

<style lang="scss">
@import "~@/assets/scss/index";
</style>